import { delay } from 'redux-saga'
import {
	call,
} from 'redux-saga/effects'

const defaultOptions = {
	maxBackoffTime: 32000,
	maxRetries: Infinity,
	resetTime: 60000,
}

function *exponentialBackoff(_function, args = [], options = defaultOptions) {
	options = {
		...defaultOptions,
		...options,
	}
	let exponentialCounter = 0
	let retryCount = 0
	let initTime
	const {maxRetries, maxBackoffTime} = options
	let result
	let hasSucceeded = false
	while (!hasSucceeded && retryCount++ < maxRetries) {
		try {
			initTime = Date.now()
			result = yield call(_function, ...args)
			hasSucceeded = true
		} catch (err) {
			const newTime = Date.now()
			if (newTime - initTime > options.resetTime) {
				exponentialCounter = 0
				retryCount = 0
			}
			const currentConnectionDelay = Math.min(Math.pow(2, exponentialCounter) * 1000, maxBackoffTime)
			yield call(delay, currentConnectionDelay + Math.random() * 2000)
			exponentialCounter += 1
		}
	}
	return result
}

export default exponentialBackoff
